<h2 mat-dialog-title>
  {{
    (data.alternativeCode ? 'Edit Alternative Code' : 'Add Alternative Code')
      | translate
  }}
</h2>
<mat-dialog-content>
  <form [formGroup]="form">
    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Alternative Code' | translate }}</mat-label>
        <input
          matInput
          formControlName="alternative_code"
          [placeholder]="'Enter alternative code' | translate"
          required
        />
        @if (
          form.get('alternative_code')?.invalid &&
          form.get('alternative_code')?.touched
        ) {
          <mat-error>{{
            'Alternative code is required' | translate
          }}</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Provider (optional)' | translate }}</mat-label>
        <mat-select formControlName="id_provider">
          <mat-option [value]="null">{{ 'None' | translate }}</mat-option>
          @for (provider of data.providers; track provider.id_provider) {
            <mat-option [value]="provider.id_provider">
              {{ provider.nombre }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Unit (optional)' | translate }}</mat-label>
        <mat-select formControlName="id_unit">
          <mat-option [value]="null">{{
            'Same as article' | translate
          }}</mat-option>
          @for (unit of data.units; track unit.id_unit) {
            <mat-option [value]="unit.id_unit">
              {{ unit.description }} ({{ unit.dian_code }})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-group">
      <label>{{ 'Packaging Components (optional)' | translate }}</label>
      @if (isFactorLocked) {
        <div class="standard-conversion-notice">
          <strong>{{ 'Standard conversion' | translate }}</strong>
          <br />
          <small>{{
            'Factor is locked based on standard unit conversion from database'
              | translate
          }}</small>
        </div>
      }
      <div class="packaging-factor-container">
        <mat-form-field appearance="outline" class="packaging-input">
          <mat-label>{{ 'Packages' | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="0.01"
            step="0.01"
            formControlName="packaging_quantity"
            placeholder="1"
          />
        </mat-form-field>
        <span class="packaging-operator">×</span>
        <mat-form-field appearance="outline" class="packaging-input">
          <mat-label>{{ 'Units/pkg' | translate }}</mat-label>
          <input
            matInput
            type="number"
            min="0.01"
            step="0.01"
            formControlName="units_per_package"
            placeholder="1"
          />
        </mat-form-field>
        <span class="packaging-operator">=</span>
        <mat-form-field appearance="outline" class="packaging-result">
          <mat-label>{{ 'Factor' | translate }}</mat-label>
          <input
            matInput
            type="number"
            [value]="calculatedFactor"
            readonly
            class="readonly-field"
          />
        </mat-form-field>
      </div>
      <small class="form-text text-muted">
        {{ 'Example: 2 × 12 = 24 (2 boxes of 12 units)' | translate }}
      </small>
    </div>

    <div class="form-group">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Description (optional)' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="description"
          rows="2"
          [placeholder]="'e.g., Box of 12 units' | translate"
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    {{ 'Cancel' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
    [disabled]="form.invalid"
  >
    {{ 'Save' | translate }}
  </button>
</mat-dialog-actions>
